.verifyEmail .iconContainer {
  display: flex;
  align-items: center;
  justify-content: center;
}
.verifyEmail .icon {
  margin: var(--cxy-spacing-4) var(--cxy-spacing-4) var(--cxy-spacing-4) 0;
  color: var(--cxy-color-brand);
  height: 50px !important;
}
.verifyEmail .title {
  font-size: var(--cxy-fontSize-xxl);
  font-weight: bold;
  display: flex;
  align-items: center;
  color: var(--cxy-color-content-default);
}
.verifyEmail .content {
  display: flex;
  flex-direction: column;
  gap: var(--cxy-spacing-2);
}
.verifyEmail .text {
  font-size: var(--cxy-fontSize-m);
  color: var(--cxy-color-content-default);
}
.verifyEmail .resendLink {
  /* Reset native <button> chrome so this reads as inline text in the sentence (matching the legacy
     myoc-login-2018 design), not a boxed control. */
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
}
.verifyEmail .resendLink:disabled {
  cursor: default;
  opacity: 0.6;
}
.verifyEmail .errorMessage {
  font-size: var(--cxy-fontSize-m);
  color: var(--cxy-color-content-error);
}
